import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { parseColor } from '../utils';
import { getCSSProperty } from '../../utils';

function color(_ref, theme) {
  var backgroundColor = _ref.backgroundColor,
      borderColor = _ref.borderColor,
      borderBottomColor = _ref.borderBottomColor,
      borderLeftColor = _ref.borderLeftColor,
      borderRightColor = _ref.borderRightColor,
      borderTopColor = _ref.borderTopColor,
      color = _ref.color,
      fill = _ref.fill,
      outlineColor = _ref.outlineColor,
      stroke = _ref.stroke,
      styles = _objectWithoutPropertiesLoose(_ref, ["backgroundColor", "borderColor", "borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor", "color", "fill", "outlineColor", "stroke"]);

  var colorProps = {
    backgroundColor: backgroundColor,
    borderColor: borderColor,
    borderBottomColor: borderBottomColor,
    borderLeftColor: borderLeftColor,
    borderRightColor: borderRightColor,
    borderTopColor: borderTopColor,
    color: color,
    fill: fill,
    outlineColor: outlineColor,
    stroke: stroke
  };
  Object.keys(colorProps).forEach(function (key) {
    var colorProp = colorProps[key];

    if (colorProp) {
      styles[key] = theme && theme.colors ? theme.colors[colorProp] ? getCSSProperty('colors', colorProp) : parseColor(colorProp) : parseColor(colorProp);
    }
  });
  return styles;
}

export default color;